(function () {
  'use strict';
  var shopify = window.Shopify || {};
  var theme = shopify.theme || {};
  if (shopify.shop !== 'wnpeis-af.myshopify.com' || (theme.role !== 'main' && !['200292041091', '200299544963', '200502608259'].includes(String(theme.id))) || !['unpublished', 'main'].includes(theme.role) || window.location.hostname !== 'getswitches.com') return;

  if (window.__gsStudioCartReadiness) return;
  var desired = new Map();
  var desiredIdentities = new Map();
  var editing = new Map();
  var writes = new Set();
  var desiredNote = null;
  var noteEdited = false;
  var knownCart = null;
  var historyReloading = false;
  try { knownCart = JSON.parse(document.getElementById('gs-configurator-checkout-settings').getAttribute('data-settings')).cart; } catch (_) {}
  function identity(item) {
    if (!item || !item.variant_id || !item.properties || Array.isArray(item.properties) || typeof item.properties !== 'object') return null;
    var properties = Object.keys(item.properties).sort().map(function (name) { return [name, item.properties[name]]; });
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
    return JSON.stringify([String(item.variant_id), properties, plan ? String(plan.id) : null]);
  }
  function lineIdentity(key) {
    var items = knownCart && knownCart.items;
    if (!Array.isArray(items)) return null;
    var item = items.find(function (item) { return item.key === key; });
    var value = identity(item);
    return value && items.filter(function (item) { return identity(item) === value; }).length === 1 ? value : null;
  }
  function desire(key, quantity) {
    desired.set(key, quantity);
    var value = lineIdentity(key);
    if (value) desiredIdentities.set(key, value);
  }
  function confirmLineKey(cart, key, quantity, value) {
    if (!value || !key || quantity < 1 || desired.get(key) !== quantity || editing.has(key) || cart.items.some(function (item) { return item.key === key; })) return;
    var matches = cart.items.filter(function (item) { return identity(item) === value; });
    if (matches.length !== 1 || matches[0].quantity !== quantity || typeof matches[0].key !== 'string') return;
    if (desired.has(matches[0].key) && (desired.get(matches[0].key) !== quantity || desiredIdentities.get(matches[0].key) !== value)) return;
    desired.delete(key);
    desiredIdentities.delete(key);
    desired.set(matches[0].key, quantity);
    desiredIdentities.set(matches[0].key, value);
  }
  function cartRoot(source) {
    var root = source && source.closest && source.closest('m-cart,m-cart-drawer');
    if (root && !root.isConnected) return document.querySelector(root.tagName.toLowerCase());
    return root;
  }
  function scoped(root) {
    return Boolean(root && root.querySelector('[data-gs-studio-item]'));
  }
  function lineKey(root, line, input) {
    var row = input && input.closest('[data-cart-item]') || root && root.querySelector('[data-cart-item][data-index="' + Number(line) + '"]');
    var field = row && row.querySelector('[data-key]');
    return field && field.getAttribute('data-key');
  }
  function signal(name) {
    document.dispatchEvent(new CustomEvent(name));
  }
  function recordQuantity(event) {
    var input = event.target.closest && event.target.closest('m-quantity-input input[name="updates[]"]');
    var root = cartRoot(input);
    if (!input || historyReloading || !scoped(root)) return;
    installWrites();
    var key = lineKey(root, input.dataset.index, input);
    var quantity = input.value.trim() === '' ? NaN : Number(input.value);
    var prior = editing.get(key || input);
    if (event.type === 'input' && !(prior && prior.committed) && !writes.size && quantity === Number(input.defaultValue)) { editing.delete(key || input); if (key) { desired.delete(key); desiredIdentities.delete(key); } return; }
    editing.set(key || input, {quantity: quantity, committed: event.type === 'change' || Boolean(prior && prior.committed)});
    if (key && Number.isSafeInteger(quantity) && quantity >= 0) desire(key, quantity);
  }
  function matchesRequest(url, options, route, expected) {
    try {
      var actual = new URL(typeof url === 'string' ? url : url.url, window.location.origin);
      var wanted = new URL(route, window.location.origin);
      var body = JSON.parse(options && options.body);
      return actual.origin === window.location.origin && actual.href === wanted.href && String(options && options.method).toUpperCase() === 'POST' && expected(body);
    } catch (_) { return false; }
  }
  function observeWrite(owner, original, args, route, expected, confirmed) {
    var nativeFetch = window.fetch;
    var observed = false;
    function trackedFetch() {
      if (observed || !matchesRequest(arguments[0], arguments[1], route, expected)) return nativeFetch.apply(this, arguments);
      observed = true;
      var write = { delayed: false };
      writes.add(write);
      var timer = setTimeout(function () { write.delayed = true; signal('gs:cart-write-failed'); }, 30000);
      var result;
      try { result = nativeFetch.apply(this, arguments); }
      catch (error) { clearTimeout(timer); writes.delete(write); signal('gs:cart-write-failed'); throw error; }
      Promise.resolve(result).then(function (response) {
        if (!response.ok) throw new Error('CART_WRITE_UNCONFIRMED');
        return response.clone().json();
      }).then(function (value) {
        if (!value || !Array.isArray(value.items) || value.errors) throw new Error('CART_WRITE_UNCONFIRMED');
        if (confirmed) confirmed(value);
        knownCart = value;
      }).catch(function () { write.failed = true; }).finally(function () {
        clearTimeout(timer);
        writes.delete(write);
        signal(write.failed ? 'gs:cart-write-failed' : 'gs:cart-write-settled');
      });
      return result;
    }
    window.fetch = trackedFetch;
    try { return original.apply(owner, args); }
    finally {
      if (window.fetch === trackedFetch) window.fetch = nativeFetch;
      if (!observed) signal('gs:cart-write-failed');
    }
  }
  function installWrites() {
    var items = window.customElements && window.customElements.get('m-cart-items');
    var originalQuantity = items && items.prototype.updateQuantity;
    if (typeof originalQuantity === 'function' && !originalQuantity.__gsStudioWrite) {
      var quantity = function (line, count, name, input) {
        var root = cartRoot(this);
        if (historyReloading && root) { historyNotice(root); return; }
        if (!scoped(root)) return originalQuantity.apply(this, arguments);
        var key = lineKey(root, line, input);
        var value = Number(count);
        var currentIdentity = lineIdentity(key);
        if (key && Number.isSafeInteger(value) && value >= 0) {
          var edit = editing.get(key);
          if (edit === undefined || edit.quantity === value) { desire(key, value); editing.delete(key); }
        }
        var route = window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_change_url;
        return observeWrite(this, originalQuantity, arguments, route, function (body) { return String(body.line) === String(line) && Number(body.quantity) === value; }, function (cart) { confirmLineKey(cart, key, value, currentIdentity); });
      };
      quantity.__gsStudioWrite = true;
      items.prototype.updateQuantity = quantity;
    }
    var addons = window.customElements && window.customElements.get('m-cart-addons');
    var originalNote = addons && addons.prototype.updateCartNote;
    if (typeof originalNote === 'function' && !originalNote.__gsStudioWrite) {
      var note = function () {
        if (historyReloading && cartRoot(this)) { historyNotice(cartRoot(this)); return; }
        if (!scoped(cartRoot(this))) return originalNote.apply(this, arguments);
        var input = this.domNodes && this.domNodes.cartNote;
        if (!input || typeof input.value !== 'string') return originalNote.apply(this, arguments);
        desiredNote = input.value;
        noteEdited = true;
        var value = desiredNote;
        var route = window.MinimogSettings && window.MinimogSettings.routes && window.MinimogSettings.routes.cart_update_url;
        return observeWrite(this, originalNote, arguments, route, function (body) { return body.note === value; });
      };
      note.__gsStudioWrite = true;
      addons.prototype.updateCartNote = note;
    }
  }
  function status(source, cart) {
    var root = cartRoot(source);
    if (historyReloading && root) return 'updates_pending';
    if (!scoped(root)) return null;
    installWrites();
    if (Array.from(writes).some(function (write) { return write.delayed; })) return 'updates_failed';
    if (Array.from(editing.values()).some(function (edit) { return !Number.isSafeInteger(edit.quantity) || edit.quantity < 0; })) return 'updates_failed';
    if (writes.size || editing.size) return 'updates_pending';
    if (cart === undefined) return null;
    if (!cart || !Array.isArray(cart.items)) return 'updates_failed';
    var quantities = new Map();
    for (var item of cart.items) {
      if (!item || typeof item.key !== 'string' || !Number.isSafeInteger(item.quantity) || item.quantity < 1 || quantities.has(item.key)) return 'updates_failed';
      quantities.set(item.key, item.quantity);
    }
    for (var entry of desired) if ((quantities.get(entry[0]) || 0) !== entry[1]) return 'updates_failed';
    if (noteEdited && (cart.note || '') !== desiredNote) return 'updates_failed';
    var inputs = root.querySelectorAll('m-quantity-input input[name="updates[]"]:not(:disabled)');
    for (var input of inputs) {
      var key = lineKey(root, input.dataset.index, input);
      if (!key || input.value.trim() === '' || !quantities.has(key) || Number(input.value) !== quantities.get(key)) return 'updates_failed';
    }
    knownCart = cart;
    desired.clear();
    desiredIdentities.clear();
    desiredNote = null;
    noteEdited = false;
    return null;
  }
  window.__gsStudioCartReadiness = Object.freeze({status: status});
  document.addEventListener('input', recordQuantity, true);
  document.addEventListener('change', recordQuantity, true);
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.m-cart-addon--save[data-action="note"]');
    if (button && scoped(cartRoot(button))) installWrites();
  }, true);
  installWrites();
  if (window.customElements) ['m-cart-items', 'm-cart-addons'].forEach(function (name) { window.customElements.whenDefined(name).then(installWrites); });

  function historyNotice(root) {
    var output = root.querySelector('[data-gs-cart-history-message]');
    if (!output) {
      output = document.createElement('p');
      output.setAttribute('data-gs-cart-history-message', '');
      output.setAttribute('role', 'alert');
      output.style.margin = '12px 0';
      (root.querySelector('.m-cart-drawer__footer--wrapper,.m-cart__checkout') || root).prepend(output);
    }
    output.textContent = 'Refreshing your saved cart. If this page does not refresh, reload it before changing your cart or checking out.';
  }
  function historyAction(event) {
    if (!historyReloading || !event.target || !event.target.closest) return;
    var root = cartRoot(event.target);
    if (!root) return;
    var control = event.target.closest('m-quantity-input,m-cart-remove-button,.m-cart-addon--save,[name="checkout"],[name="update"],a[href*="/checkout"],.additional-checkout-buttons,.shopify-payment-button');
    if (event.type !== 'submit' && !control) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    historyNotice(root);
  }
  function reloadHistoryCart(event) {
    var navigation = window.performance && typeof window.performance.getEntriesByType === 'function' && window.performance.getEntriesByType('navigation')[0];
    if (historyReloading || event.persisted !== true && !(navigation && navigation.type === 'back_forward')) return;
    historyReloading = true;
    installWrites();
    document.querySelectorAll('m-cart,m-cart-drawer').forEach(historyNotice);
    window.location.reload();
  }
  ['click', 'input', 'change', 'submit'].forEach(function (name) { window.addEventListener(name, historyAction, true); });

  function failed(image) {
    if (!image || !image.matches || !image.matches('[data-gs-studio-item] img[data-gs-studio-image]')) return;
    var fallback = image.parentElement.querySelector('.gs-studio-image-fallback');
    image.hidden = true;
    if (fallback) fallback.hidden = false;
  }
  document.addEventListener('error', function (event) { failed(event.target); }, true);
  var observedCart;
  var termsObserver;
  function syncTerms() {
    document.querySelectorAll('m-cart .m-cart__checkout > .m-terms-conditons').forEach(function (terms) {
      var checkbox = terms.querySelector('input[type="checkbox"][name="agree_terms"]');
      var wrapper = terms.nextElementSibling;
      while (wrapper && !wrapper.hasAttribute('data-terms-action')) wrapper = wrapper.nextElementSibling;
      if (!checkbox || !wrapper || wrapper.tagName !== 'DIV' || !wrapper.matches('.m-cart__checkout-button') || !wrapper.querySelector('button[name="checkout"]')) return;
      wrapper.toggleAttribute('disabled', !checkbox.checked);
    });
  }
  function check() {
    installWrites();
    document.querySelectorAll('[data-gs-studio-item] img[data-gs-studio-image]').forEach(function (image) {
      if (image.complete && image.naturalWidth === 0) failed(image);
    });
    syncTerms();
    var cart = document.querySelector('m-cart');
    if (cart !== observedCart) {
      if (termsObserver) termsObserver.disconnect();
      observedCart = cart;
      if (cart) {
        termsObserver = new MutationObserver(syncTerms);
        termsObserver.observe(cart, {childList: true, subtree: true});
      }
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check, {once: true});
  else check();
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart && Array.isArray(event.detail.cart.items)) knownCart = event.detail.cart;
    check();
  });
  document.addEventListener('shopify:section:load', check);
  document.addEventListener('change', function (event) {
    if (event.target.matches && event.target.matches('m-cart .m-cart__checkout .m-terms-conditons input[name="agree_terms"]')) syncTerms();
  });
  window.addEventListener('load', check);
  window.addEventListener('pageshow', function (event) { check(); reloadHistoryCart(event); setTimeout(check, 0); });
})();
